import { z } from "zod";
import {
  API_PREFIX,
  paginatedFromDto,
  paginationMetaDtoSchema,
  type HttpClient,
} from "@nasam/kernel";
import type { CurrenciesRepository } from "../domain";
import { currencyFromDto } from "./organizationMappers";
import { currencyDtoSchema } from "./organizationDtos";

const currencyListResponseDtoSchema = z.object({
  data: z.array(currencyDtoSchema),
  meta: paginationMetaDtoSchema,
});

export function createCurrenciesHttpRepository(
  http: HttpClient,
): CurrenciesRepository {
  return {
    async list(query) {
      const response = await http.get(`${API_PREFIX}/currencies`, {
        params: query,
      });
      return paginatedFromDto(
        currencyListResponseDtoSchema.parse(response),
        currencyFromDto,
      );
    },
  };
}
